import React, { HTMLAttributes } from "react";
import styled from "styled-components";

export interface Props extends HTMLAttributes<HTMLElement> {
  /** Placement of the div in the view */
  placement?: "bottom" | "top";
  /** Indicates on which side the div is aligned */
  side?: "left" | "right";
}

const FloatingDiv = ({ ...props }: Props) => {
  return <StyledDiv {...props} />;
};

const StyledDiv = styled.div<Props>`
  position: absolute;
  top: ${(props) => getOffset("top", props.placement)};
  bottom: ${(props) => getOffset("bottom", props.placement)};
  left: ${(props) => getOffsetSide("left", props.side)};
  right: ${(props) => getOffsetSide("right", props.side)};
`;

const getOffset = (offset: string, placement?: string) => {
  return placement === offset ? "2rem" : "unset";
};

const getOffsetSide = (offset: string, placement?: string) => {
  return placement === offset ? "1rem" : "unset";
};

export default FloatingDiv;
